module.exports = __webpack_public_path__ + "quotezone-ui/img/quotezone-provided.b0244ceb.svg";